import dateFormat from "dateformat";
import { TFunction } from "next-i18next";
import {IJobItem, Job} from '../services/Jobs/@type'

export interface IDate {
    postedDate: string
    expiredDate: string
    remainingDay: number
}
export function convertISOToMillisecond(dateTime: string | number) {
    return Date.parse(String(dateTime)) / 1000
}
export const formatUpdatedDate = (item: IJobItem, t: TFunction): IDate => {
    let expiryDiffDays: number = 1
    let postedDate: null | string = null
    let remainingDay: number = 1
    try {
        const updatedDateTS = item.approvedDate
        const now = new Date()
        const today: any = new Date(dateFormat(new Date().getTime(), 'mm/dd/yyyy'))

        let updatedDate: any = new Date(Number(updatedDateTS) * 1000)
        updatedDate = new Date(dateFormat(updatedDate, 'mm/dd/yyyy'))
        let parseDate: string | string[] = dateFormat(updatedDate, 'mm/dd/yyyy').split('/') // parsed to dd/mm/yyyy
        parseDate = [parseDate[1], parseDate[0], parseDate[2]].join('/')

        postedDate =
            dateFormat(updatedDate, 'mm/dd/yyyy') === dateFormat(now, 'mm/dd/yyyy')
                ? t('Today')
                : parseDate
        const expired: any = new Date(dateFormat(new Date(Number(item.expiredDate) * 1000), 'mm/dd/yyyy'))
        const diffTimeExpiry: any = Math.abs(expired - today)
        expiryDiffDays = Math.ceil(diffTimeExpiry / (1000 * 60 * 60 * 24))
        if (remainingDay < 1) remainingDay = 1
    } catch (e) {
        console.warn(`There is some issue with this job: `, item)
        console.warn('[ERROR caught]: ', e)
    }

    if (postedDate === null) postedDate = ''


    return {
        postedDate: postedDate,
        expiredDate: `${expiryDiffDays === 0
            ? t('Expires on today')
            : `${t('Expires: ')} ${t('in')} ${expiryDiffDays} ${t('day')}${expiryDiffDays > 1 ? t('s') : ''
            }`
            }`,
        remainingDay: expiryDiffDays
    }
}


export const remainingDayNode = (remainingDay: number, t: TFunction) => {
    if (remainingDay === 0) {
        return `${t('Expire')} <strong>${t('Today')}!</strong>`
    }
    if (remainingDay > 0) {
        return `${t('You have')} <strong>${remainingDay}</strong> ${remainingDay === 1 ? t('day to apply') : t('days to apply')}`
    }
}


export function checkIsNew(item: IJobItem) {
    const onlineDate = new Date(Number(item.onlineDate) * 1000)
    const now = new Date()
    let isNew = false
    try {
        isNew = dateFormat(onlineDate, 'yyyy/mm/dd') === dateFormat(now, 'yyyy/mm/dd')
    } catch {
        isNew = false
    }
    return isNew
}
